export function normalizeApiDateTime(value: unknown): string | null | unknown {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    if (typeof value === 'string') {
        return value;
    }

    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? value : value.toISOString();
    }

    if (typeof value === 'object') {
        const serializableValue = value as { toISOString?: () => string };

        if (typeof serializableValue.toISOString === 'function') {
            try {
                return serializableValue.toISOString();
            } catch {
                // Fall through to generic parsing.
            }
        }
    }

    const parsedDate = new Date(value as string | number | Date);

    if (!Number.isNaN(parsedDate.getTime())) {
        return parsedDate.toISOString();
    }

    return value;
}

